export const DEFAULT_PAGE_NO = 1;
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE_SIZES = [10, 20, 50];
export const DEFAULT_ALL_PAGE_SIZE = 1000;
